<div class="loader-wrapper">

  <div class="backdrop"></div>

  <mat-spinner mode="indeterminate" color="primary" diameter="50"></mat-spinner>

</div>
